module.exports = __webpack_public_path__ + "ce59b2e6.svg";